import { useSelector, useDispatch } from 'react-redux';
import { removeItem } from '../services/cartSlice';
import { useNavigate } from 'react-router-dom';

const CartModal = ({ isOpen, onClose }) => {
  const items = useSelector(state => state.cart.items);
  const total = useSelector(state => state.cart.total);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  if (!isOpen) return null;

  const formattedTotal = (Number(total) || 0).toFixed(2);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto">
        <h2 className="text-2xl font-bold mb-4">Shopping Cart</h2>
        {items.map(item => (
          <div key={item.id} className="flex items-center gap-4 mb-4">
            <img src={item.photos?.[0]} alt={item.name} className="w-20 h-20 object-cover" />
            <div className="flex-1">
              <h3 className="font-semibold">{item.name}</h3>
              <p>${item.price}</p>
              <div className="flex">
                <button 
                  onClick={() => dispatch(removeItem(item.id))}
                  className="btn btn-sm"
                >
                  Remove
                </button>
              </div>
            </div>
          </div>
        ))}
        <div className="border-t pt-4 mt-4">
          <p className="text-xl font-bold">Total: ${formattedTotal}</p>
          <div className="flex gap-4 mt-4">
            <button onClick={onClose} className="btn btn-ghost">
              Close
            </button>
            <button 
              onClick={() => {
                navigate('/checkout');
                onClose();
              }} 
              className="btn btn-primary"
            >
              Proceed to Checkout
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartModal;